import { combineReducers } from '@reduxjs/toolkit';
import productCategoriesReducer from '../productCategories/reducers';
import printerCategoriesReducer from '../printerCategories/reducers';
import autoMessagesReducer from '../autoMessages/reducers';
import rankMappingReducer from '../rankMapping/reducers';

// Combine reducers for all category types
const categoryManagementReducer = combineReducers({
    productCategories: productCategoriesReducer,
    printerCategories: printerCategoriesReducer,
    autoMessages: autoMessagesReducer,
    rankMapping: rankMappingReducer
});

export default categoryManagementReducer;
